import { render, staticRenderFns } from "./LCP.vue?vue&type=template&id=27a9eeea&scoped=true&"
import script from "./LCP.vue?vue&type=script&lang=js&"
export * from "./LCP.vue?vue&type=script&lang=js&"
import style0 from "./LCP.vue?vue&type=style&index=0&id=27a9eeea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9eeea",
  null
  
)

export default component.exports